// added extensions
export * from './card'
export * from './card-template'
export * from './card-stats'
export * from './day-plan'
export * from './study-order-progress'
export * from './study-order-template'
export * from './study-setting'
export * from './study-phase'
export * from './app-availability'
export * from './included-module-info'
// added constructor with parameter destructuring
export * from './day-plan-module'
export * from './module-stats'
export * from './overall-stats'
export * from './spaced-rep-module-config'
// override readonly id! for frontend model
export * from './module-template'
export * from './level-template'
export * from './group-template'
export * from './category-template'
// not exposed by @longtail-education
export * from './classroom-join-request'
export * from './day-plan-request'
export * from './day-plan-response'
export * from './card-retrieval-request'
export * from './study-library-request'
export * from './study-library-response'
export * from './classroom-join-response'

// missing study engine params
export const Constants = {
  UPPER_LIMIT_NOT_EQUAL_CARD_SCORE_FOR_ACQUISITION: 1.0,
  MATURITY_POINT_CAP_FOR_PROGRESS: 37,
  MINIMUM_DAILY_REVIEW_CARD_COUNT: 20,
  MAXIMUM_DAILY_REVIEW_CARD_COUNT: 100,
  ESTIMATED_TIME_PER_CARD: 8,
  MATURITY_POINTS_FOR_DONE_CARD: 999,
}

export {
  MER,
  OrientationInfo,
  DeviceOrientation,
  Topic,
  ConceptInfo,
  ConceptTemplate,
  DeckMode,
  LibrarySection,
  LibrarySectionItem,
  PopApplication,
  PopDataType,
  SpacedRepInfo,
  SubjectInfo,
  SubjectTemplate,
  UserInfo,
  PrivateUserInfo,
  MailChimpTag,
  MailChimpUserProfile,
  AuthCodeGenerationRequest,
  AuthCodeGenerationResponse,
  AuthCodeVerificationRequest,
  AuthCodeVerificationResponse,
  UserFeedback
} from '@longtail-education/superprep-data-model-frontend'

export {
  ConceptStats,
  ApplicationProfile,
  ApplicationSetting,
  RangedOverallStats,
  StudySession,
  UserResponse,
  UserStatsRange,
  RangedModuleStats,
} from '@longtail-education/superprepstudy-data-model-frontend'
